export default (name) => window?.env?.[name] || process.env[name];
